import { Tag } from "lucide-react";
import { usePublishedPrices } from "../../lib/productPrices";
import { PriceDetails } from "../product/PriceDetails";
import { PRICE_PAIRS } from "../../data/info/materiaal";

const Cell = ({ p, label, testid }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <p className="text-[15px] font-semibold text-ink">{label}</p>
    {p ? <div className="mt-3"><PriceDetails p={p} testid={`${testid}-details`} /></div>
      : <p className="mt-2 text-[14.5px] leading-relaxed text-slate-600">Nog geen gecontroleerde richtprijs. U ontvangt vrijblijvend een persoonlijke prijsindicatie.</p>}
  </div>
);

// Alleen door de eigenaar goedgekeurde bedragen (Beheer → Prijzen). Zonder goedgekeurde bedragen: geen prijzen, alleen uitleg.
export const MaterialPrices = () => {
  const prices = usePublishedPrices();
  if (!prices.__ready) return <div className="h-32 animate-pulse rounded-2xl bg-slate-100" />;
  const rows = PRICE_PAIRS.filter((r) => prices[r.kunststof] || prices[r.aluminium]);
  if (!rows.length) {
    return (
      <div className="card flex gap-4 p-6 sm:p-7" data-testid="materiaal-prices-none">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><Tag className="h-5 w-5" aria-hidden="true" /></span>
        <div>
          <h3 className="text-[18px] font-semibold text-ink">Prijs op maat van uw woning</h3>
          <p className="mt-1.5 max-w-2xl text-[15px] leading-relaxed text-slate-600">Wij publiceren alleen richtprijzen die wij zelf hebben gecontroleerd. In het algemeen is kunststof de voordeligste keuze en ligt aluminium hoger, vooral bij grote maten en speciale kleuren. Wat dat voor uw woning betekent, hoort u in een persoonlijke prijsindicatie.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="space-y-8" data-testid="materiaal-prices">
      {rows.map((r) => (
        <div key={r.label}>
          <h3 className="text-[18px] font-semibold text-ink">{r.label}</h3>
          <div className="mt-3 grid gap-4 md:grid-cols-2">
            <Cell p={prices[r.kunststof]} label={`Kunststof ${r.label.toLowerCase()}`} testid={`materiaal-price-${r.kunststof}`} />
            <Cell p={prices[r.aluminium]} label={`Aluminium ${r.label.toLowerCase()}`} testid={`materiaal-price-${r.aluminium}`} />
          </div>
        </div>
      ))}
    </div>
  );
};
